import React, { useState } from 'react';
import VolumeWinRateComboChart from '../charts/VolumeWinRateComboChart';
import SessionDurationSummary from './SessionDurationSummary';

const SessionPanel = ({ trades = [] }) => {
  const [view, setView] = useState('weekly');

  return (
    <div>
      {/* Toggle header */}
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">
          Session Analysis
        </span>
        <div className="flex items-center gap-1 bg-muted rounded-md p-0.5">
          <button
            onClick={() => setView('weekly')}
            className={`px-3 py-1 text-xs font-medium rounded transition-colors ${
              view === 'weekly'
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            Weekly Activity
          </button>
          <button
            onClick={() => setView('details')}
            className={`px-3 py-1 text-xs font-medium rounded transition-colors ${
              view === 'details'
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            Session Details
          </button>
        </div>
      </div>

      {view === 'weekly' && (
        <div className="bg-card text-card-foreground rounded-lg shadow-sm border border-border p-4">
          <VolumeWinRateComboChart trades={trades} title="" height={320} maxWeeks={12} />
        </div>
      )}
      {view === 'details' && (
        <SessionDurationSummary trades={trades} />
      )}
    </div>
  );
};

export default SessionPanel;
